import {
    PaymentMethodDetailParameters,
    useInvalidateRepositoryQuery,
    useRepositoryQuery,
} from '@mews-commander/data-access';

export const usePaymentMethodDetails = ({ id, accountId, paymentMethod }: PaymentMethodDetailParameters) =>
    useRepositoryQuery('paymentMethodDetails', 'get', { id, accountId, paymentMethod });

export const useInvalidatePaymentMethodDetails = () => {
    const invalidateRepositoryQuery = useInvalidateRepositoryQuery();

    return ({ id, accountId, paymentMethod }: PaymentMethodDetailParameters) => {
        void invalidateRepositoryQuery('paymentMethodDetails', 'get', { id, accountId, paymentMethod });
    };
};
